import TemplateList, {
  Template,
} from "../../components/Templates/TemplateList";
import { useState, useEffect } from "react";
import { getBaseTemplates } from "../../apis/templateApi/baseTemplateView";
import SubHeader from "../../layouts/subheader/SubHeader";

const AllTemplates = () => {
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const fetchedTemplates = await getBaseTemplates();

        if (Array.isArray(fetchedTemplates)) {
          setTemplates(fetchedTemplates);
        } else {
          console.error("Unexpected response format:", fetchedTemplates);
          setTemplates([]);
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
        setTemplates([]);
      }
    };
    fetchTemplates();
  }, []);

  return (
    <div className="tab-page-layout-1">
      <SubHeader title="All Templates" createHandler={true} />
      <TemplateList templates={templates} />
    </div>
  );
};

export default AllTemplates;
